module.exports = __webpack_public_path__ + "static/img/guanggan.a1b407e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanggan.png
// module id = vpc9
// module chunks = 208